import {useIntl} from 'react-intl';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ECV1Link from '../../../../common/components/ECV1Link';
import React from 'react';

interface SeeOrderTrackingConversationIconProps {
    orderId: string;
    collectInfos?: string[];
}

const SeeOrderTrackingConversationIcon = ({
    orderId,
    collectInfos,
}: SeeOrderTrackingConversationIconProps): JSX.Element => {
    const intl = useIntl();

    return (
        <div style={{display: 'inline-block'}} >
            <span className="mx-1"></span>
            {collectInfos?.includes(orderId) && (
                <ECV1Link
                    path={'collecteinformation/listingforms'}
                    className={'menu-link without-sub mr-4'}
                >
                    <OverlayTrigger
                        overlay={
                            <Tooltip>
                                <span>{intl.formatMessage({id: 'ORDERS.CONVERSATION.COLLECTION'})}</span>
                            </Tooltip>
                        }
                        placement={'top'}
                    >
                        <i
                            className="fa-solid fa-triangle-exclamation fs-1"
                            style={{color: '#FFD43B'}}
                        ></i>
                    </OverlayTrigger>
                </ECV1Link>
            )}
            <span className="mx-1"></span>
            <Link rel="noreferrer" to={`/orders/${orderId}#tracking-messages`}>
                <OverlayTrigger
                    overlay={
                        <Tooltip>
                            <span>
                                {intl.formatMessage({id: 'ORDER_TRACKING.SHOW_CONVERSATION'})}
                            </span>
                        </Tooltip>
                    }
                    placement={'top'}
                >
                    <i className="fs-1 fa-solid fa-envelopes-bulk"></i>
                </OverlayTrigger>
            </Link>
        </div>
    );
};

export default SeeOrderTrackingConversationIcon;
